// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#striped-light .card {
  margin: 0;
}

form .col-form-label {
  font-weight: 400;
  text-transform: none;
  letter-spacing: normal;
}

.adjustmentAmount {
  width: 50%;
}`, "",{"version":3,"sources":["webpack://./src/app/commission/modals/editadjustment.screen.component.scss"],"names":[],"mappings":"AAGC;EACC,SAAA;AAFF;;AAMA;EACC,gBAAA;EACG,oBAAA;EACA,sBAAA;AAHJ;;AAKA;EACE,UAAA;AAFF","sourcesContent":["\n\n#striped-light {\n\t.card {\n\t\tmargin:0;\n\t}\n}\n\nform .col-form-label {\n\tfont-weight: 400;\n    text-transform: none;\n    letter-spacing: normal;\n}\n.adjustmentAmount{\n  width:50%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
